import React from 'react';
import { Typography, Space } from 'antd';
import type { RefineLayoutThemedTitleProps } from '@refinedev/antd';
import { useParams } from 'react-router-dom';

export const ThemedTitle: React.FC<RefineLayoutThemedTitleProps> = ({ collapsed, wrapperStyles }) => {
  const { displayMode } = useParams();

  const title = displayMode === 'admin' ? 'RHYNEX V2 - ADMIN' : 'RHYNEX V2';

  return (
    <Space
      style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: 'inherit',
        ...wrapperStyles,
      }}
    >
      {!collapsed && (
        <Typography.Title
          style={{
            fontSize: '2rem',
            color: '#0050B3',
            marginBottom: '1rem',
            fontWeight: 500,
          }}
        >
          {title}
        </Typography.Title>
      )}
    </Space>
  );
};
